<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <v-card flat>
      <v-card-text class="px-0">
        <h3 class="mb-5 px-4">{{ $t('Dokumentų sąrašas') }}</h3>
        <ntr-dokumentai-search
          class="mt-1 mb-1"
          :loading="loading"
          @search="searchPerduoti"
        />
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="filterItemList"
          :search="search"
          :hide-default-footer="hideFooter"
          :footer-props="{
            showFirstLastPage: true,
            showCurrentPage: true,
            itemsPerPageText: this.$t('Rodyti po:'),
            itemsPerPageAllText: this.$t('visi'),
            itemsPerPageOptions: itemsPerPageOptions,
          }"
          :sort-by.sync="pagination.sort"
          :sort-desc.sync="pagination.sortDesc"
          :server-items-length="pagination.total"
          :items-per-page="pagination.pageSize"
          :page.sync="pagination.page"
          @update:options="updatePagination"
          :expanded.sync="expanded"
          item-key="pra_id"
        >
          <template #[`item.dokumentas`]="{ item }">
            <v-row dense no-gutters>
              <v-col cols="12" md="12">
                <el-prasymas-busena
                  class="my-1"
                  :busena="item.pra_busena_pavadinimas"
                />
              </v-col>
              <v-col cols="12" md="12">
                <b>{{ item.pra_id }}</b>
              </v-col>
              <v-col cols="12" md="12">
                {{ item.pra_tipas_pavadinimas }}
              </v-col>
            </v-row>
          </template>
          <template #[`item.salys`]="{ item }">
            <v-row dense no-gutters>
              <v-col cols="12" md="12">
                <v-row dense no-gutters>
                  <v-col
                    cols="12"
                    md="12"
                    v-for="salis in item.salis1"
                    :key="salis"
                  >
                    {{ salis }}
                  </v-col>
                  <v-col cols="12" md="12" v-if="item.salis1Cut">
                    ...
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="mt-2" cols="12" md="12">
                <v-row dense no-gutters>
                  <v-col
                    cols="12"
                    md="12"
                    v-for="salis in item.salis2"
                    :key="salis"
                  >
                    {{ salis }}
                  </v-col>
                  <v-col cols="12" md="12" v-if="item.salis2Cut">
                    ...
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </template>
          <template #[`item.turtas`]="{ item }">
            <v-row dense no-gutters>
              <v-col
                v-for="turtas in item.turtai"
                :key="turtas[0]"
                class="mb-2"
                cols="12"
                md="12"
              >
                <div>{{ turtas[0] }}</div>
                <div class="text-gray">{{ turtas[1] }}</div>
              </v-col>
              <v-col cols="12" md="12" v-if="item.turtaiCut">
                ...
              </v-col>
            </v-row>
          </template>
          <template #[`item.numatoma_pasalinimo_data`]="{ item }">
            <div class="nowrap center">{{ item.numatoma_pasalinimo_data }}</div>
          </template>
          <template #[`item.actions`]="{ item }">
            <div>
              <el-byla
                v-for="byla in item.bylos"
                :key="byla.byl_id"
                :byla="byla"
                in-line
              />
              <el-table-action
                :item="item"
                @editItem="editItem(item)"
                @viewItem="editItem(item)"
                @deleteItem="deleteItem(item)"
              />
            </div>
            <el-button
              v-if="item.canPasirasyti"
              small
              :loading="loading"
              @click.native="pasirasytiItem(item)"
              >{{ $t('Pasirašyti') }}</el-button
            >
            <el-button
              v-if="item.canMoketi"
              small
              :loading="loading"
              @click.native="moketiItem(item)"
              >{{ $t('Mokėti') }}</el-button
            >
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length - 2" class="pazyma-expanded">
              {{ $t('Atmetimo priežastis:') }}
              {{ item.atmetimo_priezastis }}
            </td>
            <td colspan="2" class="pazyma-expanded"></td>
          </template>
          <template slot="loading">
            {{ $t('Kraunasi...') }}
          </template>
          <template slot="no-results">
            {{ $t('Duomenų nėra') }}
          </template>
          <template slot="no-data">
            {{ $t('Duomenų nėra') }}
          </template>
          <template #[`footer.page-text`]="props">
            {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }}
            {{ $t('iš') }}
            {{ props.itemsLength }}
          </template>
        </v-data-table>

        <modal-delete
          :title="$t('Šalinti dokumentą?')"
          :text="
            $t('Ar norite pašalinti rengiamą dokumentą') +
              ` <strong>${modalDeleteVardas}</strong>?`
          "
          v-model="showDelete"
          :item="modalDeleteItem"
          @confirmDelete="confirmDelete"
        />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import NtrDokumentaiSearch from './NtrDokumentaiSearch'
import ModalDelete from '../modals/ModalDelete'
import NtrPaslaugosMap from './NtrPaslaugosMap'
import prasymasVeiksmas from '@/mixins/prasymasVeiksmas'
import PazymaMap from '../pazyma/PazymaMap'

export default {
  name: 'NtrDokumentai',
  components: {
    NtrDokumentaiSearch,
    ModalDelete,
  },
  mixins: [prasymasVeiksmas],
  data() {
    return {
      loading: true,
      search: null,
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      modalConfirmTitle: null,
      modalConfirmText: null,
      modalConfirmItem: null,
      showConfirm: false,
      prasymai: [],
      veiksmasLoading: null,
      searchData: {},
      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
      paginationloading: false,
      expanded: [],
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('Dokumentas'),
          align: 'start',
          sortable: false,
          value: 'dokumentas',
          width: 190,
        },
        {
          text: this.$t('Šalys'),
          align: 'start',
          sortable: false,
          value: 'salys',
          width: 170,
        },
        {
          text: this.$t('Nekilnojamasis turtas'),
          align: 'start',
          sortable: false,
          value: 'turtas',
        },
        {
          text: this.$t('Numatoma pašalinimo data'),
          align: 'center',
          sortable: false,
          value: 'numatoma_pasalinimo_data',
          width: 100,
        },
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
          width: 80,
        },
      ]
    },
    filterItemList() {
      return this.prasymai.map(prasymas => {
        const prasymasMap = NtrPaslaugosMap.getPrasymasTipas(prasymas.pra_tipas)
        prasymas.routeList = 'ntrDokumentai'
        prasymas.routeSign = 'ntrDokumentai'

        const maxSalis = 3
        prasymas.salis1Cut = false
        prasymas.salis2Cut = false
        if (prasymas.salis1.length > maxSalis) {
          prasymas.salis1 = prasymas.salis1.slice(0, maxSalis)
          prasymas.salis1Cut = true
        }
        if (prasymas.salis2.length > maxSalis) {
          prasymas.salis2 = prasymas.salis2.slice(0, maxSalis)
          prasymas.salis2Cut = true
        }

        const maxTurtai = 3
        prasymas.turtaiCut = false
        if (prasymas.turtai.length > maxTurtai) {
          prasymas.turtai = prasymas.turtai.slice(0, maxTurtai)
          prasymas.turtaiCut = true
        }

        if (!prasymas.paz_id && prasymas.pra_busena !== 'rengiamas') {
          prasymas.numatoma_pasalinimo_data = null
        }

        prasymas.bylos = prasymas.bylos.map(byla => {
          return {
            ...byla,
            byl_url: `ntrpaslaugos/byla/${byla.byl_id}/${byla.byl_hash}/content`,
          }
        })

        prasymas.canView = prasymas.veiksmai.includes('savitarna-perziura')
        prasymas.canEdit = prasymas.veiksmai.includes('savitarna-redagavimas')
        prasymas.canDelete = prasymas.pra_busena == 'rengiamas'

        prasymas.canPasirasyti = prasymas.veiksmai.includes(
          'savitarna-pasirasymas'
        )
        prasymas.canMoketi = prasymas.veiksmai.includes('savitarna-mokejimas')

        prasymas.routeEdit = prasymas.canEdit
          ? prasymasMap.routeEdit
          : prasymasMap.routeView
        prasymas.routeSign = prasymasMap.routeSign

        if (prasymas.pra_busena === 'laukia_patvirtinimo' && !prasymas.paz_id) {
          prasymas.pra_busena_pavadinimas = this.$t('Laukia pasirašymo')
          prasymas.routeEdit = prasymasMap.routeEdit
        }

        if (prasymas.paz_id) {
          prasymas.canView = prasymas.veiksmai.includes('pazyma-perziura')
          prasymas.canEdit = prasymas.veiksmai.includes('pazyma-redagavimas')
          prasymas.canDelete = prasymas.veiksmai.includes('pazyma-salinimas')
          prasymas.canMoketi = prasymas.veiksmai.includes('pazyma-mokejimas')

          if (prasymas.pra_busena === 'atmestas') {
            this.expanded.push({ pra_id: prasymas.pra_id })
          }
          if (
            prasymas.pra_busena === 'ivykdytas' &&
            prasymas.bylos.length == 0
          ) {
            prasymas.numatoma_pasalinimo_data = null
          }
        }

        return prasymas
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
  },
  created() {
    // this.getData()
    this.pageloading = true
  },
  methods: {
    getData(resetPageNr = false) {
      this.loading = true

      if (resetPageNr) {
        this.pagination.page = 1
      }

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`ntrpaslaugos/rengti-dokumentai`, data)
        .then(res => {
          this.prasymai = res.data.prasymas
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    searchPerduoti(searchData) {
      this.searchData = searchData
      this.getData(true)
    },
    editItem(item) {
      if (item.paz_id) {
        this.editPazyma(item)
        return
      }
      this.editPrasymas(item)
    },
    pasirasytiItem(item) {
      this.editPrasymas(item, true)
    },
    moketiItem(item) {
      if (item.paz_id) {
        this.moketiSavitarnaPazyma(item.paz_id)
        return
      }

      this.moketiSavitarna(item.pra_id)
    },
    editPrasymas(prasymas, registravimas = false) {
      const prasymasID = prasymas.pra_id
      this.$store.dispatch('prasymasID', prasymasID).then(
        this.$store.dispatch('prasymasTipas', prasymas.pra_tipas).then(() => {
          const listInfo = {
            prasymasID: prasymasID,
            routeName: prasymas.routeList,
          }
          this.$store.dispatch('listInfo', listInfo).then(() => {
            if (registravimas) {
              this.$router.push({
                name: prasymas.routeSign,
                params: {
                  prasymasID: prasymasID,
                  step: 'registravimas',
                },
              })
              return
            }
            this.$router.push({
              name: prasymas.routeEdit,
              params: {
                prasymasID: prasymasID,
                step: 'registravimas',
              },
            })
          })
        })
      )
    },
    editPazyma(pazyma) {
      const pazymaID = pazyma.paz_id
      const pazymaMap = PazymaMap.getPazymaTipas(pazyma.pra_tipas)

      this.$store.dispatch('pazymaID', pazymaID).then(
        this.$store.dispatch('pazymaTipas', pazyma.pra_tipas).then(() => {
          const listInfo = {
            pazymaID: pazymaID,
            routeName: pazyma.routeList,
          }
          this.$store.dispatch('listInfo', listInfo).then(() => {
            this.$router.push({
              name: pazymaMap.routeEdit,
              params: {
                pazymaID: pazymaID,
              },
            })
          })
        })
      )
    },
    deleteItem(item) {
      this.modalDeleteVardas = `${item.pra_id}. ${item.pra_tipas_pavadinimas}`
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    confirmDelete(item) {
      if (item.paz_id) {
        this.confirmDeletePazyma(item)
        return
      }
      this.confirmDeletePrasymas(item)
    },
    confirmDeletePrasymas(item) {
      this.$axios
        .delete(`ntrpaslaugos/prasymas/${item.pra_id}`)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    confirmDeletePazyma(item) {
      this.$axios
        .delete(`ntrpaslaugos/pazyma/${item.paz_id}`)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
  },
}
</script>
<style lang="scss">
.pazyma-expanded {
  box-shadow: none;
  background: rgb(248, 248, 248);
  padding-top: 0px;
}

.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
</style>
